import { type FC, useEffect, useRef } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import {
    clearSbPhotosBackLink,
    getSbPhotosBackLink,
    type BackLinkPayload,
} from 'dibs-interiors-photos/exports/sbInteriorsModuleBackLinkHelpers';

import styles from './PhotosSearchBrowseBackLink.scss';

export const PhotosSearchBrowseBackLink: FC = () => {
    const backLink = getSbPhotosBackLink() as BackLinkPayload | undefined;
    const backLinkRef = useRef<BackLinkPayload | undefined>();

    useEffect(() => {
        if (backLink) {
            backLinkRef.current = backLink;
            clearSbPhotosBackLink();
        }
    }, [backLink]);

    if (!backLinkRef.current?.linkUrl) {
        return null;
    }

    return (
        <Link
            className={styles.link}
            dataTn="sb-photos-back-link"
            href={backLinkRef.current.linkUrl}
        >
            <FormattedMessage
                id="abt.PhotosSearchBrowseBackLink.link"
                defaultMessage="Back to {displayName}"
                values={{
                    displayName: backLinkRef.current.displayName,
                }}
            />
        </Link>
    );
};
